import React, { useEffect } from "react";
import BreadcrumbsHeader from "../breadcrumbs/BreadcrumbsHeader";
import { Link } from "react-router-dom";
import Brands1 from "../brands/Brands1";
import { FaArrowRight } from "react-icons/fa";
import "aos/dist/aos.css";
import AOS from "aos";

const servicesData = [
  {
    title: "AI Development",
    icon: "/images/ai.png",
    description:
      "Process automation, customer service automation, and business operations efficiency enhancement through custom-built AI solutions.",
    animation: "slideInLeft",
  },
  {
    title: "Analytics and Business Intelligence",
    icon: "/images/web.png",
    description:
      "Dynamic dashboards along with real-time data visualizations and actionable insights derived from raw data.",
    animation: "fadeInDown",
  },
  {
    title: "Predictive and Preemptive Analytics",
    icon: "/images/solution-services-icons/video-marketing.png",
    description:
      "AI recommendation engines and forecasting tools strengthen preemptive strategic business decisions.",
    animation: "slideInLeft",
  },
  {
    title: "Machine Learning & Deep Learning",
    icon: "/images/solution-services-icons/Influence-marketing.png",
    description:
      "Develop and implement self-updating learning algorithms intended for the perpetual advancement and mechanization of processes.",
    animation: "fadeInUp",
  },
  {
    title: "Big Data Engineering",
    icon: "/images/solution-services-icons/viral-marketing.png",
    description:
      "Developed with the intention of maintaining and processing immense amounts of data; may it be structured or unstructured.",
    animation: "slideInRight",
  },
  {
    title: "Healthcare",
    icon: "/images/health.png",
    description:
      "Diagnosing and interpreting scans using AI aides, predictive analytics of patient re-admission, EHR analytics, and remote patient monitoring.",
    animation: "slideInRight",
  },
  {
    title: "Retail & eCommerce",
    icon: "/images/ecom.png",
    description:
      "Customer trend analysis alongside automatic pricing changes and forecasting inventory with enhanced supply chain analytics.",
    animation: "slideInRight",
  },
  {
    title: "Finance",
    icon: "/images/solution-services-icons/payonclick.png",
    description:
      "Automated credit scoring processes and machine learning powered real-time fraudulent transaction detection.",
    animation: "slideInRight",
  },
  {
    title: "Manufacturing",
    icon: "/images/manu.png",
    description:
      "Reduction of downtime and predictive maintenance with analysis of IoT data related to production efficiency.",
    animation: "slideInRight",
  },
];

const AiAnalytics = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <div>
      <BreadcrumbsHeader
        title="AI & Analytic Solutions"
        backgroundImage="/images/aibanner.jpg"
      />

      <section className="about-section section-home-secondary1">
        <div className="vertical-title hidden-md">
          <span className="vertical-text-main">ISOLS Group</span>
          <span className="vertical-text-additional">DM</span>
        </div>

        <div className="container">
          <div className="row">
            {/* Left Column */}
            <div className="col-xs-12 col-sm-6 about-content">
              <div className="heading">
                <p className="first-heading">
                  Achieving Intelligent Business Results Through
                </p>
                <h1 className="heading-line">
                  <strong>Innovation with Data</strong>
                </h1>
              </div>

              <div className="about-description">
                <p>
                  The AI & Analytic unit within ISOLS Group strives to assist
                  businesses in harnessing the potential of their data. From
                  customer relationship management to operational optimization,
                  our AI-driven solutions empower businesses to make strategic
                  decisions based on absolute certainty. We apply the latest
                  technologies in artificial intelligence, machine learning, and
                  analytics to create intelligent systems that learn, adjust,
                  and grow along with your operations.
                </p>
              </div>
            </div>

            {/* Right Column */}
            <div className="col-xs-12 col-sm-6 about-image text-center">
              <div className="img-brd-mod wow slideInRight">
                <div className="brd"></div>
                <div className="img-cut">
                  <div className="cut"></div>
                  <img
                    src="/images/aii.jpg"
                    className="img-responsive center-block"
                    alt="AI Analytics"
                  />
                </div>
              </div>
            </div>
          </div>
          </div>
          </section>

      <section className="section-services  pt-0 pb-5">
            <div className="container">
            <div className="b-services-holder">
                <div className="row">
                  {servicesData.map((service, index) => (
                    <div className={`col-xs-6 col-sm-4 wow ${service.animation}`}  key={index}>
                      <div className="b-services-item">
                        <div className="services-icon">
                          <img src={service.icon} alt={service.alt} />
                        </div>
                        <div className="services-text">
                          <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                            {service.title}
                          </h6>
                          <p>{service.description}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
      
              <div className="row">
             <div className="col-md-12">
              <div className="knowmorebtn">
                <Link to="/award-certifications" className="btn btn-default-arrow btn-sm">
                <FaArrowRight />
                Know more
                </Link>
                <p>about various technology solutions & services offered by Innovative Solution Technologies - A technology wing of ISOLS Group</p>
              </div>
              </div>
             </div>
            </div>
          </section>
      <Brands1 />
    </div>
  );
};

export default AiAnalytics;
